import cities from './cities';
import municipalities from './ES/municipalities'
import { replaceAccent } from '../utils/string'

export const roleLabel = Object.freeze({
  hrmanager: 'Manager de RH',
  solicitant: 'Solicitante'
});

export const levelOptions = [
  'Básico',
  'Intermedio',
  'Avanzado',
];

export const knowledgeLevels = [
  'Deseable',
  'Básico',
  'Intermedio',
  'Avanzado',
  'Certificado'
];

export const modalities = [
  'Híbrido',
  'Presencial',
  'Home Office',
  'Remoto por Protocolo COVID'
];

const defaultVacancyFields = {
  name: 'Nombre de la vacante',
  duration: 'Duración',
  places: 'Número de Posiciones',
  state: 'Estado',
  city: 'Ciudad',
  schedule: 'Horario',
  showScholarship: 'Mostrar Beca',
  scholarship: 'Beca',
  modality: 'Modalidad',
  degree: 'Licenciatura(s)',
  academicLevel: 'Nivel académico',
  minimumSemester: 'Semestre Mínimo',
  maximumSemester: 'Semestre Máximo',
  excelLevel: 'Nivel de Excel',
  englishLevel: 'Nivel de Inglés',
  graduateDate: 'Termino de Materias',
  degreeDate: 'Titulación',
  skills: 'Habilidades',
  knowledges: 'Conocimientos',
  goal: 'Objetivo',
  benefit: 'Beneficios',
  activities: 'Actividades Diarias',
  author: 'Contacto de la empresa',
  authorName: 'Nombre',
  authorEmail: 'Correo electrónico',
  authorPhone: 'Teléfono',
  project: 'Proyecto',
  comments: 'Comentarios',
};

export const trainingTypes = {
  'university-training': 'Formación Universitaria',
  'professional-training': 'Formación Profesional',
}

export const trainingDurations = {
  "1-month": "1 mes",
  "3-months": "3 meses",
  "6-months": "6 meses",
  "9-months": "9 meses",
  "12-months": "12 meses",
  "18-months": "18 meses",
  "24-months": "24 meses",
  "36-months": "36 meses",
}

export const academicLevels = {
  en: {
    "student": "Student",
    "recently-graduated": "Recently graduated",
    "experienced-graduated": "Experienced graduated",
  },
  mx: {
    "student": "Estudiante",
    "recently-graduated": "Recién graduado",
    "experienced-graduated": "Graduado con experiencia",
  },
  es: {
    "student": "Estudiante",
    "recently-graduated": "Titulado sin experiencia",
    "experienced-graduated": "Titulado con experiencia",
  },
}

export function getDefaultVacancyFields (location) {
  if (location) {
    return location === 'mx'
      ? defaultVacancyFields
      : {
        ...defaultVacancyFields,
        state: "Provincia",
        goal: 'Descripción',
        activities: 'Funciones',
        benefit: 'Condiciones',
        minimumSemester: 'Curso mínimo',
        maximumSemester: 'Curso máximo',
        degree: 'Grado(s)',
        showScholarship: 'Mostrar remuneración',
        scholarship: 'Remuneración',
        maxPhoneDigits: '9',
      }
  }
  return defaultVacancyFields
}

export function getStateCities (stateId, location) {
  if (location) {
    const items = location === 'mx' ? cities : municipalities;
    return items
      .filter(city => city.state_id === stateId)
      .sort((a, b) => {
        const nameA = replaceAccent(a.name)
        const nameB = replaceAccent(b.name)
        if (nameA > nameB) {
          return 1
        }
        if (nameA < nameB) {
          return -1
        }
        return 0
      })
  }
  return []
}

export const knowledgeLevelsObject = knowledgeLevels.reduce((acc, level) => {
  // Quitando acentos de la propiedad pero no del valor
  const key = level.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  acc[key] = level;
  return acc;
}, {});
